import apiClient from './apiClient';

export const getSstFormatByClientId = async (clientId) => {
  try {
    const response = await apiClient.get(`/sst-format/by-format/${clientId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSstFormatByVehicleAndDate = async (vehicleId, month, year) => {
  try {
    // Build date range for the month
    const startDate = `${year}-${String(month + 1).padStart(2, '0')}-01`;
    const lastDay = new Date(year, month + 1, 0).getDate();
    const endDate = `${year}-${String(month + 1).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;

    
    const response = await apiClient.get(`/sst-format/by-vehicle/${vehicleId}`, {
      params: {
        startDate,
        endDate
      }
    });
    
    return response.data;
  } catch (error) {
    // If endpoint doesn't exist, return empty data
    return { data: [] };
  }
};
